<template>
  <div id="page-forms">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-card-text class="">
          <profile-form></profile-form>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import ProfileForm from "@/components/widgets/form/ProfileForm";

export default {
  name: "UserProfile",
  components: {
    ProfileForm
  },
  created() {
    this.$store.dispatch("fetchProfile").catch(() => {});
  }
};
</script>

<style scoped></style>
